import CommonService from './common';
import { WEB_SSO } from '../../../utils/urls';
import { encryptParams } from '../../../utils/index';

export default class RegisterService extends CommonService {
  /**
   * [email register xhr]
   * @param {string} params -- requeset body data
   */
  private emailRegisterXhr = (params: any) => {
    return this.request({
      url: WEB_SSO.EMAIL_REGISTER,
      method: 'POST',
      data: params,
    });
  };
  /**
   * [email register]
   * @param {string} email email
   * @param {string} next redirect url after successful registration
   * @param {string} code code
   * @param {string} token token in email verification link
   * @param {string} password account password
   * @param {string} email_logic_type const
   */
  public emailRegister = (params: {
    email: string;
    next?: string;
    code?: string;
    token?: string;
    password?: string;
    email_logic_type?: number;
    extra_params?: object;
  }) => {
    let { email, extra_params = {}, ...rest } = params;
    const data = encryptParams(
      { email, ...rest, ect_type: 1, ...extra_params },
      ['email', 'code', 'password']
    );
    return this.emailRegisterXhr(data);
  };
  // /**
  //  * [email register and bind mobile] out-of-date
  //  * @param {string} email email
  //  * @param {string} code code
  //  * @param {string} mobile mobile
  //  * @param {string} password password
  //  */
  // public emailRegisterAndBindMoblie(params: {
  //   email?: string;
  //   code: string;
  //   mobile: string;
  //   password: string;
  // }) {
  //   let { email, code, mobile, password, ...extra_params } = params;
  //   const data = encryptParams(
  //     { email, code, mobile, password, ...extra_params },
  //     ['email', 'code', 'mobile', 'password']
  //   );
  //   return this.emailRegisterXhr(data);
  // }

  /**
   * [email register and bind mobile V2]
   * @param {string} email email
   * @param {string} code code
   * @param {string} mobile mobile
   * @param {string} password password
   */
  public emailRegisterAndBindMoblieV2 = (params: {
    email?: string;
    code: string;
    mobile: string;
    password: string;
    extra_params?: object;
  }) => {
    let { email, code, mobile, password, extra_params = {}, ...rest } = params;
    const data = encryptParams(
      { email, code, mobile, password, ...rest, ...extra_params },
      ['email', 'code', 'mobile', 'password']
    );
    return this.request({
      url: WEB_SSO.EMAIL_REGISTER_V2,
      method: 'POST',
      data,
    });
  };

  /**
   * [mobile register and bind email V2]
   * @param {string} email email
   * @param {string} code code
   * @param {string} mobile mobile
   * @param {string} password password
   */
  public mobileRegisterAndBindEmailV2 = (params: {
    email?: string;
    code: string;
    mobile: string;
    password: string;
    extra_params?: object;
  }) => {
    let { email, code, mobile, password, extra_params = {}, ...rest } = params;
    const data = encryptParams(
      { email, code, mobile, password, ...rest, ...extra_params },
      ['email', 'code', 'mobile', 'password']
    );
    return this.request({
      url: WEB_SSO.MOBILE_REGISTER_WITH_EMAIL,
      method: 'POST',
      data,
    });
  };

  /**
   * [login by email code]
   * @param {string} email email
   * @param {string} next redierct url
   * @param {string} code verify code
   * @param {string} token verify token
   */
  public emailActivateCodeLogin = (params: {
    email: string;
    next?: string;
    code?: string;
    token?: string;
    extra_params?: object;
  }) => {
    let { email, code, extra_params = {}, ...rest } = params;
    const data = encryptParams(
      { email, code, ...rest, ect_type: 13, ...extra_params },
      ['email', 'code']
    );
    return this.request({
      url: WEB_SSO.EMAIL_ACTIVATE_CODE_LOGIN,
      method: 'POST',
      data,
    });
  };

  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCode = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCode({
      ...rest,
      type: 16,
      ...extra_params,
    });
  };

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCodeV2 = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCodeV2({
      ...rest,
      type: 16,
      ...extra_params,
    });
  };

  /**
   * [send a verification url to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  public sendEmailLink = (params: {
    email: string;
    next: string;
    password?: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailLink({
      ...rest,
      ect_type: 1,
      ...extra_params,
    });
  };

  /**
   * [send a verification url to email V2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  public sendEmailLinkV2 = (params: {
    email: string;
    next: string;
    password?: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailLinkV2({
      ...rest,
      ect_type: 1,
      ...extra_params,
    });
  };

  /**
   * [send a verification code to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  public sendEmailCode = (params: {
    email: string;
    next: string;
    password?: string;
    email_logic_type?: number;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailCode({
      ...rest,
      ect_type: 1,
      ...extra_params,
    });
  };

  /**
   * [send a verification code to email V2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  public sendEmailCodeV2 = (params: {
    email: string;
    next?: string;
    password?: string;
    email_logic_type?: number;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailCodeV2({
      ...rest,
      ect_type: 1,
      ...extra_params,
    });
  };
}
